// src/application.ts
import type { StyleMap, mxConstants, mxGraph } from '@deity-io/mxgraph'; // <- import types only
import mx from 'services/mxGraph/mx'; // <- import values from factory()

export const getDefaultVertexStyle = (graph: mxGraph) => {
  const style = graph.stylesheet.getDefaultVertexStyle();
  style[mx.mxConstants.STYLE_PERIMETER] = mx.mxPerimeter.RectanglePerimeter;
  style[mx.mxConstants.STYLE_SHADOW] = false;
  style[mx.mxConstants.STYLE_VERTICAL_ALIGN] = mx.mxConstants.ALIGN_TOP;
  style[mx.mxConstants.STYLE_ALIGN] = mx.mxConstants.ALIGN_CENTER;
  style[mx.mxConstants.STYLE_RESIZABLE] = '0';
  style[mx.mxConstants.STYLE_WHITE_SPACE] = 'wrap';
  delete style[mx.mxConstants.STYLE_FILLCOLOR];
  delete style[mx.mxConstants.STYLE_STROKECOLOR];

  return style;
};

export const getDefaultEdgeStyle = (graph: mxGraph, style?: mxConstants) => {
  const edgeStyle = graph.stylesheet.getDefaultEdgeStyle();
  edgeStyle[mx.mxConstants.STYLE_ENDARROW] = mx.mxConstants.ARROW_BLOCK;
  edgeStyle[mx.mxConstants.STYLE_ROUNDED] = 1;
  edgeStyle[mx.mxConstants.STYLE_ALIGN] = mx.mxConstants.ALIGN_CENTER;
  edgeStyle[mx.mxConstants.STYLE_VERTICAL_ALIGN] = mx.mxConstants.ALIGN_MIDDLE;
  edgeStyle[mx.mxConstants.STYLE_FONTSIZE] = '10';
  edgeStyle[mx.mxConstants.VALID_COLOR] = '#27bf81';
  edgeStyle[mx.mxConstants.STYLE_STROKECOLOR] = '#bebfd0';
  edgeStyle[mx.mxConstants.STYLE_STROKEWIDTH] = '2';

  edgeStyle[mx.mxConstants.STYLE_EDGE] = style || mx.mxConstants.EDGESTYLE_ENTITY_RELATION;

  edgeStyle[mx.mxConstants.STYLE_BENDABLE] = '1';

  return edgeStyle;
};

export const getDefaultPortStyle = (graph: mxGraph) => {
  const style: StyleMap = {};
  style[mx.mxConstants.STYLE_SHAPE] = mx.mxConstants.SHAPE_IMAGE;
  style[mx.mxConstants.STYLE_FONTCOLOR] = '#774400';
  style[mx.mxConstants.STYLE_PERIMETER] = mx.mxPerimeter.RectanglePerimeter;
  style[mx.mxConstants.STYLE_PERIMETER_SPACING] = '6';
  style[mx.mxConstants.STYLE_ALIGN] = mx.mxConstants.ALIGN_CENTER;
  style[mx.mxConstants.STYLE_VERTICAL_ALIGN] = mx.mxConstants.ALIGN_MIDDLE;
  style[mx.mxConstants.STYLE_FONTSIZE] = '10';
  style[mx.mxConstants.STYLE_FONTSTYLE] = 2;

  // style[mx.mxConstants.STYLE_IMAGE_WIDTH] = "16";
  // style[mx.mxConstants.STYLE_IMAGE_HEIGHT] = "16";
  return style;
};
